import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DetailTextButton from '../atoms/DetailTextButton';
import EditTextButton from '../atoms/EditTextButton';
import DeleteTextButton from '../atoms/DeleteTextButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  groupMenus: PropTypes.arrayOf(
    PropTypes.shape({
      menuId: PropTypes.number,
      groupName: PropTypes.string,
      menuName: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
      taxType: PropTypes.string,
      image: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const GroupGochiMenuTableBody = enhance(
  ({
    menus,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    editOpenAction,
    deleteOpenAction,
    order,
    orderBy,
    roles
  }) => {
    const sortedResult = _.orderBy(menus, orderBy, order);
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(gochiMenu => {
            const params = {
              id: gochiMenu.menuId
            };
            return (
              <TableRow key={gochiMenu.menuId} hover>
                <TableCell>
                  <EditTextButton
                    id={gochiMenu.menuId}
                    onClickAction={editOpenAction}
                  />
                </TableCell>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{gochiMenu.groupId}</TableCell>
                )}
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{gochiMenu.menuId}</TableCell>
                )}
                <TableCell>{gochiMenu.groupName}</TableCell>
                <TableCell>{gochiMenu.menuName}</TableCell>
                <TableCell>{gochiMenu.price}</TableCell>
                <TableCell>{gochiMenu.taxTypeStr}</TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
                <TableCell>
                  <DeleteTextButton
                    id={gochiMenu.menuId}
                    onClickAction={deleteOpenAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(GroupGochiMenuTableBody);
